<template>
  <div class="agenda-box" data-scroll-section>
    <GiestTitle :title="title"></GiestTitle>
    <div class="agenda-fix">
      <div class="main-forum" v-if="mainForum.zones">
        <div class="forum-title">
            <strong class="slidetop" data-scroll data-scroll-call="animateMove">
              {{mainForum.title}}
              <vue-typed-js :strings="[mainForum.time]" :loop="true"
                :startDelay="300"
                :typeSpeed="100"
                :backSpeed="50">
                <time class="typing"></time>
              </vue-typed-js>
            </strong>
            <small data-scroll data-scroll-speed="-1" data-scroll-direction="horizontal">{{mainForum.title_en}}</small>
        </div>
        <div class="main-forum-wrap">
          <div class="main-form-time">
            <figure>
              <img v-if="mainForum.zones[0].cover" :src="mainForum.zones[0].cover" alt=""/>
              <img v-else src="@/assets/images/mouse3.png" alt=""/>
            </figure>
            <div class="main-forum-info">
              <time>{{mainForum.zones[0].start_time}}<i>-</i>{{mainForum.zones[0].end_time}}</time>
              <p>{{mainForum.zones[0].subtitle}}</p>
            </div>
          </div>
          <div class="common-forum">
            <ul class="common-forum-list">
              <li v-for="(item) in mainForum.zones[0].sessions" :key="item.id">
                <time>{{item.from_time}}<i>-</i>{{item.to_time}}</time>
                <div class="common-forum-li">
                  <strong>{{item.title}}</strong>
                  <div class="form-desc">
                    <div v-for="(itemDesc, indexd) in item.guest" :key="indexd">
                      <p>{{itemDesc.title}}<span>{{itemDesc.user | lineBreak}}</span></p>
                    </div>
                  </div>
                  <!-- <p>{{item.guest[0].title}}</p> -->
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="other-forum">
        <div class="other-forum-item" v-for="items in forumData" :key="items.id">
          <div class="forum-title">
              <strong class="slidetop" data-scroll data-scroll-call="animateMove">
                {{items.title}}
                <vue-typed-js :strings="[items.time]" :loop="true"
                  :startDelay="300"
                  :typeSpeed="100"
                  :backSpeed="50">
                  <time class="typing"></time>
                </vue-typed-js>
              </strong>
              <small data-scroll data-scroll-speed="-1" data-scroll-direction="horizontal">{{items.title_en}}</small>
          </div>
          <div class="other-forum-li">
            <div class="other-forum-info" v-for="(itemInfo) in items.zones" :key="itemInfo.id">
              <div class="other-forum-tops">
                <time>{{itemInfo.start_time}}<i>-</i>{{itemInfo.end_time}}</time>
                <strong>{{itemInfo.subtitle}}</strong>
                <img :src="itemInfo.cover" alt=""/>
              </div>
              <ul class="common-forum-list">
                <li v-for="(itemlist) in itemInfo.sessions" :key="itemlist.id">
                  <time>{{itemlist.from_time}}<i>-</i>{{itemlist.to_time}}</time>
                  <div class="common-forum-li">
                    <strong>{{itemlist.title}}</strong>
                    <!-- <p>{{itemlist.description}}</p> -->
                    <!-- <div class="form-desc">
                      <p v-for="(itemDesc, indexd) in itemlist.guest" :key="indexd">
                        <span v-for="(itemName, indexs) in itemDesc.title.replace(/\s*$/,'').split(' ')" :key="indexs">{{itemName}}</span><span>{{itemDesc.user}}</span>
                      </p>
                    </div> -->
                    <div class="form-desc">
                      <div v-for="(itemDesc, indexd) in itemlist.guest" :key="indexd">
                        <p>{{itemDesc.title}}<span>{{itemDesc.user | lineBreak}}</span></p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GiestTitle from '@/components/guest/GuestTitle'
export default {
  data () {
    return {
      title: {
        en: 'agenda',
        zh: '大会议程'
      },
      forumData: [],
      mainForum: {}
    }
  },
  props: {
    scroll: Object
  },
  methods: {
    async getForum () {
      const { data: res } = await this.$http.get('/alL_sessions')
      if (res.code === 1) {
        const resData = res.data
        this.mainForum = resData[0]
        this.forumData = resData
        this.forumData.splice(0, 1)
        this.forumData[1] = this.forumData.splice(0, 1, this.forumData[1])[0]
        console.log(this.mainForum)
        this.$set(this.mainForum, 'time', this.$filter.timeFormat(this.mainForum.zones[0].the_date, 'mm.dd'))
        this.forumData.forEach((item, index) => {
          this.$set(item, 'time', this.$filter.timeFormat(item.zones[0].the_date, 'mm.dd'))
        })
        setTimeout(() => {
          this.scroll.update()
        }, 400)
      }
    }
  },
  filters:{
    lineBreak:function(data){
      return data.replace(/<br>/g,' ');
    }
  },
  components: {
    GiestTitle
  },
  mounted () {
    this.getForum()
     console.log(22)
  }
}
</script>

<style lang="less" scoped>
  @import url("@/assets/css/home/index.less");
  @import url("@/assets/css/agenda/index.less");
</style>